export const ROOT = "/";
export const LOGIN = "/login";
export const REGISTER_PATH = "/signup";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const USER_HOME = "/home";
export const PROJECTS = "/home/projects";
export const MY_PROJECTS = `${PROJECTS}/me`;
export const SHARED_WITH_ME_PROJECTS = `${PROJECTS}/shared-with-me`;
export const TEMPLATES_SCREEN = "/templates";
export const ALL_TEMPLATES_BY_FORMAT = "/templates/{0}";
export const ALL_TEMPLATES_BY_FORMAT_PATH = "/templates/:format";

export const SEARCH_TEMPLATES_SCREEN = "/search/templates";
// export const TEMPLATES_BY_FORMAT_SCREEN = "/templates/{0}";
// export const TEMPLATES_BY_FORMAT_SCREEN_PATH = "/templates/:format";
// export const TEMPLATES_BY_CATEGORY_SCREEN_PATH = "/templates/:format/:category";
export const TEMPLATES_BY_FORMAT_SCREEN = "/search/{0}";
export const TEMPLATES_BY_FORMAT_SCREEN_PATH = "/search/:format";
export const TEMPLATES_BY_CATEGORY_SCREEN = "/search/{0}/{1}";
export const TEMPLATES_BY_CATEGORY_SCREEN_PATH = "/search/:format/:category";
export const SEARCH_TEMPLATES_BY_FORMAT_SCREEN = `${SEARCH_TEMPLATES_SCREEN}/{0}`
export const SEARCH_TEMPLATES_BY_FORMAT_SCREEN_PATH = `${SEARCH_TEMPLATES_SCREEN}/:format`;
export const VIDEO_TEMPLATES = "/templates/videos";
export const QUICK_START = "/dashboard";
export const LAYOUTS = "/home/layouts";
export const MY_ASSETS = "/home/assets";
export const MY_COPIES = "/home/copies";
export const TEAM_TEMPLATES = "/home/templates";
export const MY_TEMPLATES = `${TEAM_TEMPLATES}/me`;
export const SHARED_WITH_ME_TEMPLATES = `${TEAM_TEMPLATES}/shared-with-me`;
export const MY_COMPONENTS = "/home/components";
export const MY_FOLDERS = "/home/folders";
export const FOLDER_CONTENTS_PATH = "/home/folders/:folderId";
export const FOLDER_CONTENTS = "/home/folders/{0}";
export const STORY = "/designs";
export const STORY_DETAIL = "/designs/{0}/{1}/{2}";
export const PREVIEW = "/preview/{0}/{1}";
export const RENDER_PREVIEW = "/render/:org/:designId";
export const PREVIEW_PATH = "/preview/:org/:designId";
export const STORY_DETAIL_PATH = "/designs/:org/:designId";
export const STORY_DETAIL_NAME_PATH = "/designs/:org/:designId/:name";
export const STORY_PAGE_PATH = "/designs/:org/:designId/:name/:pageId";
export const REGISTRATION_EMAIL_SENT = "/registration/confirm-email";
export const CONFIRM_EMAIL = "/registration/account-confirm-email/:key";
export const VERIFICATION_STATUS_PATH = "/verified";
export const REGISTRATION_VERIFICATION_SUCCESS = "/verified/success";
export const REGISTRATION_VERIFICATION_FAILURE = "/verified/failure";
export const SETTINGS = "/settings";
export const MY_ACCOUNT = `${SETTINGS}/myaccount`;
export const MY_WORKSPACE = `${SETTINGS}/myworkspace`;
export const REWARDS = `${SETTINGS}/rewards`;
export const BILLING_AND_PAYMENT = `${SETTINGS}/billing`;
export const BILLING_PLANS = `${SETTINGS}/billing/plans`;
export const BILLING_CHECKOUT = `${SETTINGS}/billing/checkout`;
export const MY_APPS = `${SETTINGS}/myapps`;
export const EMAIL_PREFERENCES = `${SETTINGS}/email-preferences`;
export const BRANDKIT = `${SETTINGS}/brandkit`;
export const PASSWORD_RESET_EMAIL_SENT = "/forgot-password/confirm-email";
export const CONFIRM_PASSWORD_RESET = "/reset/:uid/:token";
export const PASSWORD_RESET_STATUS = "/reset";
export const PASSWORD_RESET_SUCCESS = "/reset/success";
export const PASSWORD_RESET_FAILURE = "/reset/failure";
export const PASSWORD_SET_SUCCESS_VIA_INVITATION = "/password-set/success";
export const PASSWORD_SET_FAILURE_VIA_INVITATION = "/password-set/failure";
export const CREATE_PASSWORD_VIA_INVITATION = "/invitations/:token";
export const ACCESS_DENIED = "/403";
export const UNAUTHORIZED = "/401";
export const NOT_FOUND = "/404";
export const INTERNAL_SERVER_ERROR = "/500";
export const CREATE_WORKSPACE = "/create/workspace";
export const ADD_NEW_MEMBERS = "/workspace/invite";
export const OAUTH_SHOPIFY_CALLBACK = "/shopify/callback";
export const OAUTH_GENERIC_WAITING_SCREEN = "/oauth2/wait";
export const SHOPIFY_LOGIN = "/shopify";
export const AI_WRITER = '/ai-writer';
export const MAGICAL = AI_WRITER;
export const AI_TEMPLATE = `${AI_WRITER}/short/{0}`;
export const AI_DOCUMENT = `${AI_WRITER}/document/{0}`;
export const AI_DOCUMENT_PATH = `${AI_WRITER}/document/:promptId`;
export const AI_TEMPLATE_PATH = `${AI_WRITER}/short/:promptId`;
export const AI_NEW_DOCUMENT = `${AI_WRITER}/new`;
export const PLAYGROUND = `${AI_WRITER}/playground`;
export const DOCUMENTS = `${AI_WRITER}/documents`;
export const MY_DOCUMENTS = `${DOCUMENTS}/me`;
export const SHARED_WITH_ME_DOCUMENTS = `${DOCUMENTS}/shared-with-me`;
export const FAVORITES = `${AI_WRITER}/favorites`;
export const LIFETIME = "/lifetime";
export const PUBLISHING = "/publishing";
export const ANALYTICS = "/analytics";
export const ANALYTICS_GENERATE_REPORT = "/analytics/generate-report";
export const DRAFT = "/planner/:orgId/draft/:draftId";
export const POST = "/publishing/:orgId/post/:postId";
export const PLANNER = "/planner/:category?";
export const REVIEW_PACKAGE = "/review/browse/:packageId?";
export const EXTENSION_PLANNER_NEW_POST = "/extension/planner/new-post";
export const SNAPSHOT_MAKER_TWEET_TO_IMAGE = "/tools/tweet-to-image";
export const SNAPSHOT_MAKER_GENERATE_PREVIEW = "/tools/snapshot-maker/generate-preview";
export const REMOVE_BACKGROUND = "/tools/background-remover";
export const CREATE_DESIGN_VIDEO_TEMPLATE = "/create/:format";
export const IMAGE_CONVERTER = "/tools/image-converter";
export const VIDEO_CONVERTER = "/tools/video-converter";
export const AI_SHORT_FORM_ALL = "/ai-writer/templates"
export const AI_SHORT = "/ai-writer/templates/:category";
export const AI_SEARCH_BY_CATEGORY = "/ai-writer/templates/{0}";
export const AI_WRITER_SCREEN_PATH = `${AI_WRITER}/:slug`;
export const AI_WRITER_SCREEN = `${AI_WRITER}/{0}`;
// export const AI_SEARCH = "/ai-writer/templates/{0}"

